
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientionwarmingmachine() {



  const cardData =
  {
    keyword: 'Patient Warming Machine',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Machine',
    headingDescription: 'Pharmacle Health Care Private Limited delivers high-performance Patient Warming Machine solutions in Kolkata, engineered to maintain patient body temperature during surgeries and intensive care. Our machines provide controlled and consistent warmth, helping to prevent hypothermia and improve post-operative recovery. Designed for ease of use and efficiency, our patient warming machines are widely adopted in hospitals and critical care units. Trust Pharmacle Health Care for advanced warming machines in Kolkata that enhance patient safety, comfort, and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Advanced Patient Warming Machine for Optimal Thermal Management",
    "description": "Pharmacle Health Care offers cutting-edge patient warming machines designed to regulate body temperature during surgical and post-operative care. Ensure safety, comfort, and faster recovery with our trusted solutions."
  },
  {
    "title": "Best Patient Warming Machines for Hospitals and Surgical Centers",
    "description": "Our patient warming machines deliver precise thermal control in ICUs, operating rooms, and emergency care settings. Improve patient outcomes with our high-performance medical equipment."
  },
  {
    "title": "Reliable Patient Warming Machine for Consistent Temperature Control",
    "description": "Ensure uninterrupted warming support with our dependable machines, built for continuous use in critical care environments. Pharmacle Health Care ensures patient comfort through innovation."
  },
  {
    "title": "High-Quality Patient Warming Machine for Medical Professionals",
    "description": "Our machines are engineered for accuracy, efficiency, and ease of use. Ideal for hospitals, clinics, and specialty units requiring advanced temperature regulation during procedures."
  },
  {
    "title": "Buy Patient Warming Machine for Enhanced Clinical Efficiency",
    "description": "Pharmacle Health Care’s warming machines are ideal for use in trauma care, neonatal units, and surgical departments. Boost recovery rates and patient safety with our technology-driven solutions."
  },
  {
    "title": "Technologically Advanced Patient Warming Machine for Healthcare Facilities",
    "description": "Incorporating smart temperature sensors and uniform heat distribution, our warming machines offer the latest in patient care technology. Easy to operate and maintain in all clinical settings."
  },
  {
    "title": "Affordable and Durable Patient Warming Machines",
    "description": "Get cost-effective thermal solutions without compromising quality. Pharmacle Health Care provides durable and efficient machines suitable for high-demand medical use."
  },
  {
    "title": "Trusted Supplier of Patient Warming Machines",
    "description": "Hospitals and healthcare providers rely on Pharmacle Health Care for certified, high-performance patient warming machines. We ensure consistent quality and after-sales support."
  },
  {
    "title": "Pediatric and Adult Patient Warming Machine Solutions",
    "description": "Designed for all age groups, our warming machines offer adjustable settings for safe and customized temperature control in various medical situations."
  },
  {
    "title": "Hospital-Grade Patient Warming Machine for Critical Care Use",
    "description": "Enhance medical care standards with our premium patient warming machines. Perfect for surgery, ICU, and recovery rooms, delivering reliable thermal management."
  }
],

   "services": [
    {
      "name": "Patient Warming Machine",
      "description": "Pharmacle Health Care offers patient warming machines designed to maintain optimal body temperature during medical procedures. These machines are essential for reducing the risk of hypothermia and enhancing patient outcomes."
    },
    {
      "name": "Surgical Warming Machine",
      "description": "Our surgical warming machines are engineered for use in operating rooms to provide consistent thermal support during surgery. These systems ensure patient safety by maintaining normothermia throughout procedures."
    },
    {
      "name": "Medical Temperature Control Machine",
      "description": "We provide medical temperature control machines that regulate patient body temperature during and after treatment. These machines play a vital role in preventing thermal imbalances and improving recovery rates."
    },
    {
      "name": "Hospital Warming Equipment",
      "description": "Pharmacle Health Care supplies hospital warming equipment designed for various departments, including surgery and critical care. These systems ensure reliable temperature management to support comprehensive patient care."
    },
    {
      "name": "Operating Room Heat Therapy Devices",
      "description": "Our operating room heat therapy devices offer targeted thermal support to maintain normothermia during surgical procedures. These devices are critical for maintaining temperature stability in sterile environments."
    },
    {
      "name": "Intraoperative Warming System",
      "description": "We offer intraoperative warming systems that provide precise heat delivery during surgeries. These systems help reduce the risk of hypothermia, ensuring patient comfort and safety during operations."
    },
    {
      "name": "Patient Heating Machines",
      "description": "Pharmacle Health Care provides patient heating machines for use in clinical and surgical settings. These machines help stabilize core body temperature and support faster patient recovery."
    }
  ],
  "tableData": [
    ["- Patient Warming Machine", "- Surgical Warming Machine"],
    ["- Medical Temperature Control Machine", "- Hospital Warming Equipment"],
    ["- Operating Room Heat Therapy Devices", "- Intraoperative Warming System"],
    ["- Patient Heating Machines"]
  ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced Patient Warming Machines in Kolkata, designed to deliver precise and consistent temperature control during medical treatments. Our technology prevents hypothermia and ensures patient safety in clinical settings."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a broad range of Patient Warming Machines in Kolkata, suitable for surgical, critical care, and emergency use. Our machines are engineered to maintain patient comfort and optimize clinical outcomes."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Patient Warming Machines are built to the highest quality standards, ensuring durability and reliable performance over time. Each unit undergoes strict testing to guarantee continuous and safe operation in hospitals and clinics across Kolkata."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are paramount. Our Patient Warming Machines provide controlled, gentle warmth to reduce temperature-related risks during medical procedures, ensuring a safe environment for patients in Kolkata."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Patient Warming Machines are adaptable to diverse healthcare environments in Kolkata, including operating rooms, ICUs, and emergency departments. We collaborate with healthcare providers to customize solutions that fit their needs."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s Patient Warming Machines are designed for seamless integration with existing medical equipment in Kolkata. This ensures smooth implementation without disrupting ongoing clinical workflows."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation in Kolkata to assist healthcare facilities in selecting the ideal Patient Warming Machines. Our support team provides ongoing maintenance and service to keep your equipment operating efficiently."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort drive every innovation. Our Patient Warming Machines help maintain optimal body temperatures during critical procedures, delivering the highest standard of care in Kolkata."
    }
]

























  }

const faqData = [
  {
    question: "What is a Patient Warming Machine?",
    answer: "A Patient Warming Machine is a medical device designed to maintain a patient's body temperature by delivering controlled heat during surgeries, treatments, or recovery. It is commonly used in operating rooms and critical care settings to prevent hypothermia."
  },
  {
    question: "How does a Patient Warming Machine function?",
    answer: "The machine works by generating warm air or fluid that is circulated through compatible warming blankets or pads. It allows healthcare providers to set and control the desired temperature to ensure patient safety and comfort."
  },
  {
    question: "Is the Patient Warming Machine available in Kolkata?",
    answer: "Yes, Pharmacle Health Care Private Limited supplies advanced Patient Warming Machines to medical facilities in Kolkata, ensuring optimal thermal care during patient procedures and recovery."
  },
  {
    question: "Where can Patient Warming Machines be used?",
    answer: "These machines are used in a variety of medical settings, including operating rooms, ICUs, post-operative recovery units, and emergency departments where maintaining patient temperature is critical."
  },
  {
    question: "Are Patient Warming Machines safe to use?",
    answer: "Yes, when used properly by trained medical staff, Patient Warming Machines are safe and effective. They come with temperature controls and safety features to avoid overheating or underheating."
  },
  {
    question: "How can I purchase a Patient Warming Machine from Pharmacle Health Care?",
    answer: "You can contact Pharmacle Health Care Private Limited directly. Our team will assist you with choosing the right model and facilitate the purchase and delivery to your facility in Kolkata."
  }
];

const testimonialsData = [
  {
    text: "We have been using the Patient Warming Machine from Pharmacle Health Care in our operating room. It provides consistent and reliable temperature control, which is crucial for patient safety during surgery.",
    name: "Dr. Meera Basu"
  },
  {
    text: "The Patient Warming Machines from Pharmacle Health Care have enhanced our post-op care significantly. Their performance and support services are exceptional.",
    name: "Sunrise Multispeciality Clinic, Kolkata"
  }
];



  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



 
  const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Patient Warming Machine",
  "description": "Advanced Patient Warming Machines designed for precise temperature control during surgical procedures and patient care. Ensure safety and comfort with our reliable warming equipment.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5154"
  }
};




  

  return (
    <div>
  
<Helmet>
  <title>Patient Warming Machine | Contact: +91 8956322311</title>
  <meta
    name="description"
    content="Advanced Patient Warming Machines for precise temperature control during surgeries and patient care. Contact us at +91 8956322311."
  />
  <meta
    name="keywords"
    content="Patient Warming Machine, Surgical Warming Machine, Medical Temperature Control Machine, Hospital Warming Equipment, Operating Room Heat Therapy Devices, Intraoperative Warming System, Patient Heating Machines"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/62.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientionwarmingmachine;